


































import { Mobile } from "@/mixins/mobile";
import Component, { mixins } from "vue-class-component";

@Component
export default class PageHeadline extends mixins(Mobile) {
  get showBackButton(): boolean {
    let show = true;
    if (
      this.$route.path.includes("collection") ||
      this.$route.path.includes("submitted") ||
      // The user is logged out here, so there is nothing to go back to.
      this.$route.path.includes("error") ||
      this.$route.path === "/"
    ) {
      show = false;
    }
    return show;
  }
}
